export enum LIST_DISPLAY_MODES {
  LIST = 'list',
  TILES = 'tiles',
}
